module.exports = __webpack_public_path__ + "static/media/15_kucha_holstov_10.78_84.44.b554e8ea.png";